
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><path d="M13.379 3.783 8.821 1.504c-.456-.228-1.026-.228-1.539 0l-4.558 2.28c-.57.284-.912.854-.912 1.48v5.414c0 .627.342 1.254.969 1.538l4.558 2.28c.228.114.513.17.74.17.286 0 .514-.056.742-.17l4.558-2.28c.57-.284.969-.854.969-1.538V5.265a1.6 1.6 0 0 0-.969-1.482Zm-5.527-1.31c.057-.057.17-.057.228-.057.114 0 .17 0 .228.057l4.216 2.108-1.595.798-4.445-2.222 1.368-.684Zm.228 4.33L3.635 4.581l1.596-.798 4.444 2.223-1.595.797Zm-4.843 4.445a.68.68 0 0 1-.285-.513V5.493l4.558 2.28v5.583l-4.273-2.108Zm9.63 0L8.65 13.356V7.772l4.558-2.28v5.243c0 .228-.114.399-.342.513Z"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    